<div
  class="alert-container"
  [class.has-description]="!!(description$ | async)"
  [style.background-color]="backgroundColour$ | async"
  [style.border-color]="borderColor$ | async">
  <div class="alert-body align-items-center">
    <div class="overflow-auto d-flex flex-column gap-1">
      <div class="alert-title">{{ title$ | async }}</div>
      <div *ngIf="description$ | async as description" class="alert-description">{{ description }}</div>
    </div>
    <div *ngIf="showBannerButton$ | async" class="system-button" (click)="buttonClicked.emit()">
      {{ buttonText$ | async }}
    </div>
    <div *ngIf="isDismissable$ | async" class="dismiss-button" (click)="dismissClicked.emit()">
      <img class="d-block" [src]="dismissButtonSrc$ | async" alt="Dismiss" i18n-alt />
    </div>
  </div>
</div>
